<div class="modal-backdrop" role="dialog" aria-modal="true" (click)="onBackdropClick()" data-testid="modal-install-info">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeModal()" type="button" aria-label="Cerrar modal" data-testid="modal-install-info-close">
      ×
    </button>

    <div class="modal-icon">
      <svg width="91.602" height="91.602" viewBox="0 0 91.602 91.602" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(0 -0)">
          <path d="M45.8008 91.6016C20.5462 91.6016 0 71.0553 0 45.8008C0 20.5462 20.5462 0 45.8008 0C71.0553 0 91.6016 20.5462 91.6016 45.8008C91.6016 71.0553 71.0553 91.6016 45.8008 91.6016ZM45.8008 7.47774C24.6693 7.47774 7.47774 24.6693 7.47774 45.8008C7.47774 66.9323 24.6693 84.1238 45.8008 84.1238C66.9323 84.1238 84.1238 66.9323 84.1238 45.8008C84.1238 24.6693 66.9323 7.47774 45.8008 7.47774Z" fill="currentColor" />
          <path d="M15.3143 24.5252L18.4698 12.5287L20.7582 4.19851C22.6666 -4.63848 2.89419 2.86821 0 5.12497L0.233595 7.77765C2.87044 5.92473 12.8477 3.5492 10.8562 10.1136L9.96537 13.4631L9.96537 13.4631L5.41622 30.4363C3.50787 39.2733 23.2802 31.7705 26.1744 29.5098L25.9408 26.8571C23.304 28.714 13.3267 31.0896 15.3143 24.5252Z" fill="currentColor" fill-rule="evenodd" transform="translate(31.698 36.253)" />
          <path d="M6.117 12.234C9.49533 12.234 12.234 9.49533 12.234 6.117C12.234 2.73867 9.49533 0 6.117 0C2.73867 0 0 2.73867 0 6.117C0 9.49533 2.73867 12.234 6.117 12.234Z" fill="currentColor" fill-rule="evenodd" transform="translate(44.542 20.707)" />
        </g>
      </svg>
    </div>

    <h2>Accede en un solo clic</h2>

    <div class="modal-content">
      <p>Para acceder más rápido, puedes poner la webapp en la pantalla principal de tu móvil, como si fuera una app:</p>
      <section class="instruction-block">
        <h3>En iPhone (Safari):</h3>
        <ol>
          <li>Abre el enlace de la webapp en Safari.</li>
          <li class="instruction-block__share-item" (click)="share()">
            <div class="safari-share-button">
              Pulsa el botón de <a (click)="share()" class="safari-share-button-link"><strong>compartir</strong></a>.
              <img src="/images/safari-compartir.png" alt="Icono de compartir" class="share-icon" width="20px" height="25px">
            </div>
          </li>
          <li (click)="installPWA()">Selecciona <strong>"Añadir a pantalla de inicio"</strong>.</li>
          <li>Confirma y listo.</li>
        </ol>
      </section>

      <section class="instruction-block">
        <h3>En Android (Chrome):</h3>
        <ol>
          <li>Abre el enlace de la webapp en Chrome.</li>
          <li>Pulsa los tres puntos (arriba a la derecha).</li>
          <li (click)="installPWA()">Selecciona <strong>"Añadir a pantalla de inicio"</strong>.</li>
          <li>Confirma y listo.</li>
        </ol>
      </section>
    </div>

    <div class="modal-actions" *ngIf="showCloseButton">
      <square-button
        [label]="'Cerrar'"
        type="button"
        (click)="closeModal()"
        [size]="'small'"
        class="button-primary outline">
      </square-button>
    </div>
  </div>
</div>
